export const FETCH_TRIPS_REQUEST=`FETCH_TRIPS_REQUEST`;
export const FETCH_TRIPS_SUCCESS=`FETCH_TRIPS_SUCCESS`;
export const FETCH_TRIPS_ERROR=`FETCH_TRIPS_ERROR`;
export const FETCH_TRIPS_CLEAR=`FETCH_TRIPS_CLEAR`;